// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig = {
    title: 'chart.tiktok.avg_engagement_rate_history',
    tooltip: 'chart.tiktok.tooltip_avg_engagement_rate_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.tiktok.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    social: TIKTOK_BUSINESS,
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    size: SIZE_50,
    type: 'chart',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
